angular.module("ainapp")
    .controller("AddBuildingController", ["app.config", "$scope", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Add Building";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.LoadData = function (_selectedReceipt) {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.BuildingById($stateParams.BuildingId).then(function (response) {

                    $scope.Apartment = response.data;
                    $scope.Apartment.BuildDate = new Date(response.data.BuildDate);
                    $scope.Apartment.BondDate = new Date(response.data.BondDate);
                    $scope.Load = false;

                    $.LoadingOverlay("hide");

                }, function (err) {
                    toastr.error($scope.NetworkErrorLan);
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            };

            $scope.Cities = [];
            MainService.CitiesInDropdown().then(function (response) {
                $scope.Cities = response.data;
            });

            $scope.BuildingTypes = [];
            MainService.BuildingTypesInDropdown().then(function (response) {
                $scope.BuildingTypes = response.data;
            });

            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.Employees = response.data;
            });

            $scope.Particulars = [];
            MainService.ParticularsInDropdown().then(function (response) {
                $scope.Particulars = response.data;
            });

            $scope.VATs = [];
            MainService.VATsInDropdown().then(function (response) {
                $scope.VATs = response.data;
            });

            MainService.GetCompanyProfile().then(function (response) {
                $scope.CompanyProfile = response.data;

                $scope.CountryCosts = [];
                MainService.CostCenterSubList($scope.CompanyProfile.CostCenterCountryId).then(function (response) {
                    $scope.CountryCosts = response.data;
                });

                $scope.StateCosts = [];
                MainService.CostCenterSubList($scope.CompanyProfile.CostCenterStateId).then(function (response) {
                    $scope.StateCosts = response.data;
                });

                $scope.TaxCategoryCosts = [];
                MainService.CostCenterSubList($scope.CompanyProfile.CostCenterTaxCategoryId).then(function (response) {
                    $scope.TaxCategoryCosts = response.data;
                });

                $scope.VatAccTypeCosts = [];
                MainService.CostCenterSubList($scope.CompanyProfile.CostCenterVatAccountTypeId).then(function (response) {
                    $scope.VatAccTypeCosts = response.data;
                });
            })


            $scope.init = function () {

                $scope.basePath = config.basePath;
                $scope.Load = false;
                $scope.Error = "";

                $scope.Apartment = {
                    Name: "",
                    NameAr: "",
                    BuildingNo: "",
                    Location: "",
                    RentPropertyType: "",
                    Address: "",
                    ContractorName: "",
                    BuildDate: new Date(),
                    Floors: 0,
                    Area: 0,
                    Units: 0,
                    Remarks: "",
                    CityId: "",
                    WatchMenId: "",
                    BondType: "",
                    BondNo: "",
                    BondDate: new Date(),
                    GovernmentNo: "",
                    PlotNo: "",
                    LessorId: "",
                    AddressAr: "",
                    ContractorNameAr: "",
                    RemarksAr: "",
                    Status: "",
                    NoOfParking: 0,
                    RentalIncomeAccountId: "",
                    RentReceivableAccountId: "",
                    PenaltyAccountId: "",
                    AdvanceRentAccountId: "",
                    BankAccountId: "",
                    BankLoanAccountId: "",
                    ProvisionAccountId: "",
                    RentalAdvanceReceivableAccountId: "",
                    RentalAdvanceReceivableCloseAccountId: "",
                    ParkingIncomeAccountId: "",
                    ParkingAdvanceAccountId: "",
                    LandloardCommissionAccountId: "",
                    BuildingTypeId: "",


                    Title: "",
                    TitleAr: "",
                    Photo: "",
                    IsPublish: false,
                }



                if ($stateParams.BuildingId > 0) {
                    $scope.LoadData();
                } else {

                    MainService.GetNextBuildingNo().then(function (response) {
                        $scope.Apartment.Code = response.data;
                    });
                }

                $scope.ViewVal = 0;


            }
            $scope.init();



            $scope.LessorAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.SuppliersInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.NetworkErrorLan);
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.LessorAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: $scope.SearchByAccountLan,
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.Lessor = account;
                    $scope.Apartment.LessorId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.LessorAutocompleteDataSource
            };


            $scope.AccountAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.accountInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.NetworkErrorLan);
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.RentIncomeAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RentalIncomeAccount = account;
                    $scope.Apartment.RentalIncomeAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RentReceivableAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RentReceivableAccount = account;
                    $scope.Apartment.RentReceivableAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.PenaltyAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.PenaltyAccount = account;
                    $scope.Apartment.PenaltyAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.AdvanceRentAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.AdvanceRentAccount = account;
                    $scope.Apartment.AdvanceRentAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.BankAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.BankAccount = account;
                    $scope.Apartment.BankAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.BankLoanAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.BankLoanAccount = account;
                    $scope.Apartment.BankLoanAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.ProvisionAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.ProvisionAccount = account;
                    $scope.Apartment.ProvisionAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RentalAdvanceReceivableAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RentalAdvanceReceivableAccount = account;
                    $scope.Apartment.RentalAdvanceReceivableAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RentalAdvanceReceivableCloseAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RentalAdvanceReceivableCloseAccount = account;
                    $scope.Apartment.RentalAdvanceReceivableCloseAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.ParkingIncomeAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.ParkingIncomeAccount = account;
                    $scope.Apartment.ParkingIncomeAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.ParkingAdvanceAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: $scope.SearchByAccountLan,
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.ParkingAdvanceAccount = account;
                    $scope.Apartment.ParkingAdvanceAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.LandloardCommissionAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.LandloardCommissionAccount = account;
                    $scope.Apartment.LandloardCommissionAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };



            $scope.RevRentIncomeAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RevRentalIncomeAccount = account;
                    $scope.Apartment.RevRentalIncomeAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevRentReceivableAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RevRentReceivableAccount = account;
                    $scope.Apartment.RevRentReceivableAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevPenaltyAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RevPenaltyAccount = account;
                    $scope.Apartment.RevPenaltyAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevAdvanceRentAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RevAdvanceRentAccount = account;
                    $scope.Apartment.RevAdvanceRentAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevBankAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RevBankAccount = account;
                    $scope.Apartment.RevBankAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevBankLoanAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RevBankLoanAccount = account;
                    $scope.Apartment.RevBankLoanAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevProvisionAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RevProvisionAccount = account;
                    $scope.Apartment.RevProvisionAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevRentalAdvanceReceivableAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RevRentalAdvanceReceivableAccount = account;
                    $scope.Apartment.RevRentalAdvanceReceivableAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevRentalAdvanceReceivableCloseAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RevRentalAdvanceReceivableCloseAccount = account;
                    $scope.Apartment.RevRentalAdvanceReceivableCloseAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevParkingIncomeAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RevParkingIncomeAccount = account;
                    $scope.Apartment.RevParkingIncomeAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevParkingAdvanceAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: $scope.SearchByAccountLan,
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RevParkingAdvanceAccount = account;
                    $scope.Apartment.RevParkingAdvanceAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevLandloardCommissionAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RevLandloardCommissionAccount = account;
                    $scope.Apartment.RevLandloardCommissionAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.RentalPDCAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RentalPDCAccount = account;
                    $scope.Apartment.RentalPDCAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.RentalBankAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RentalBankAccount = account;
                    $scope.Apartment.RentalBankAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.VATAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.VATAccount = account;
                    $scope.Apartment.VATAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.RevRentalPDCAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RevRentalPDCAccount = account;
                    $scope.Apartment.RevRentalPDCAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.RevRentalBankAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RevRentalBankAccount = account;
                    $scope.Apartment.RevRentalBankAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.RevVATAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Apartment.RevVATAccount = account;
                    $scope.Apartment.RevVATAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };



            $scope.BPCreditAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.BParticulars.CreditAccount = account;
                    $scope.BParticulars.CreditAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.DeleteApartment = function () {
                $('#deleteModal').modal('show');
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteBuilding($scope.Apartment.Id).then(function (response) {
                    if (response.data == true) {
                        $scope.Load = false;
                        toastr.success($scope.SuccessLan);
                        $('#deleteModal').modal('hide');
                        $scope.init();
                    } else {
                        $scope.Load = false;
                        toastr.warning($scope.CannotdeleteOperationsfoundLan);
                    }
                    $.LoadingOverlay("hide");
                }, function () {
                    $.LoadingOverlay("hide");
                    toastr.error($scope.NetworkErrorLan);
                    $scope.Load = false;
                })

            }


            $scope.AddData = function () {
                $scope.Error = "";
                if ($scope.Apartment.Name == "") {
                    toastr.warning("Enter Name");
                } else if ($scope.Apartment.BuildingNo == "") {
                    toastr.warning("Enter Building No");
                } else if ($scope.Apartment.CityId == "") {
                    toastr.warning("select City");
                } else if ($scope.Apartment.Location == "") {
                    toastr.warning("Enter Location");
                } else if ($scope.Apartment.BuildingTypeId == "") {
                    toastr.warning("Select Type");
                } else if ($scope.Apartment.Floors == 0) {
                    toastr.warning("Enter Floors");
                } else if ($scope.Apartment.Area == 0) {
                    toastr.warning("Enter Area");
                } else if ($scope.Apartment.Units == 0) {
                    toastr.warning("Enter Units");
                } else if ($scope.Apartment.Address == "") {
                    toastr.warning("Enter Address");
                } else if ($scope.Apartment.LessorId == "") {
                    toastr.warning("Select Lessor");
                } else if ($scope.Apartment.NoOfParking == "") {
                    toastr.warning("Enter No Of Parking");
                } else if ($scope.Apartment.BondType == "") {
                    toastr.warning("Enter Bond Type");
                } else if ($scope.Apartment.BondNo == "") {
                    toastr.warning("Enter Bond No");
                } else if ($scope.Apartment.RentalIncomeAccountId == "") {
                    toastr.warning("Select Rental Income Account");
                } else if ($scope.Apartment.RentReceivableAccountId == "") {
                    toastr.warning("Select Rent Receivable Account");
                } else if ($scope.Apartment.PenaltyAccountId == "") {
                    toastr.warning("Select Penalty Account");
                } else if ($scope.Apartment.AdvanceRentAccountId == "") {
                    toastr.warning("Select Advance Rent Account");
                } else if ($scope.Apartment.BankAccountId == "") {
                    toastr.warning("Select Bank Account");
                } else if ($scope.Apartment.BankLoanAccountId == "") {
                    toastr.warning("Select Bank Loan Account");
                } else if ($scope.Apartment.ProvisionAccountId == "") {
                    toastr.warning("Select Provision Account");
                } else if ($scope.Apartment.RentalAdvanceReceivableAccountId == "") {
                    toastr.warning("Select Rental Advance Receivable Account");
                } else if ($scope.Apartment.RentalAdvanceReceivableCloseAccountId == "") {
                    toastr.warning("Select Rental Advance Receivable Close Account");
                } else if ($scope.Apartment.ParkingIncomeAccountId == "") {
                    toastr.warning("Select Parking Income Account");
                } else if ($scope.Apartment.ParkingAdvanceAccountId == "") {
                    toastr.warning("Select Parking Advance Account");
                } else if ($scope.Apartment.LandloardCommissionAccountId == "") {
                    toastr.warning("Select Landloard Commission Account");
                } else if ($scope.Apartment.Title == "" && $scope.Apartment.IsPublish == true) {
                    toastr.warning("Enter Title");
                } else if ($scope.Apartment.TitleAr == "" && $scope.Apartment.IsPublish == true) {
                    toastr.warning("Enter Title Arabic");
                } else if ($scope.Apartment.Photo == "" && $scope.Apartment.IsPublish == true) {
                    toastr.warning("Upload Photo");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddBuilding($scope.Apartment).then(function (response) {
                        if (response.data) {
                            $scope.Load = false;
                            toastr.success("Success");
                            $state.go("Building");
                            $scope.init();
                        } else {
                            $scope.Load = false;
                            toastr.warning("Failed");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        toastr.error("Network Error");
                        $scope.Load = false;
                    });
                }
            }

            $scope.getParticulars = function () {

                $scope.BParticulars = {
                    Amount: 0,
                    VatType: "Exclusive",
                    VATId: "",
                    ParticularsId: "",
                    CreditAccountId: "",
                    BuildingId: $scope.Apartment.Id
                }


                $scope.ViewVal = 2;

                $scope.BuildingParticulars = [];
                MainService.GetAllBuildingParticulars($scope.Apartment.Id).then(function (response) {
                    $scope.BuildingParticulars = response.data;
                });
            }

            $scope.addBuildingParticulars = function () {
                if ($scope.BParticulars.ParticularsId == "") {
                    toastr.warning("Select Particulars");
                } else if ($scope.BParticulars.CreditAccountId == "") {
                    toastr.warning("Select Credit Account");
                }  else if ($scope.BParticulars.VATId == "") {
                    toastr.warning("Select Vat");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddBuildingParticulars($scope.BParticulars).then(function (response) {
                        if (response.data) {
                            $scope.Load = false;
                            toastr.success($scope.SuccessLan);
                            $scope.getParticulars();
                        } else {
                            $scope.Load = false;
                            toastr.error($scope.NetworkErrorLan);
                        }
                        $.LoadingOverlay("hide");
                    }, function () {
                        $.LoadingOverlay("hide");
                        toastr.error($scope.NetworkErrorLan);
                        $scope.Load = false;
                    })

                }
            }

            $scope.editParticulars = function (data) {
                $scope.BParticulars = data;
            }

            $scope.selectedBPToDelete = {};
            $scope.deleteParticulars = function (data) {
                $scope.selectedBPToDelete = data;
                $('#deleteModalBP').modal('show');
            }

            $scope.deleteBPWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteBuildingParticulars($scope.selectedBPToDelete.Id).then(function (response) {
                    if (response.data == true) {
                        $scope.Load = false;
                        toastr.success($scope.SuccessLan);
                        $('#deleteModalBP').modal('hide');
                        $scope.getParticulars();
                    } else {
                        $scope.Load = false;
                        toastr.warning($scope.CannotdeleteOperationsfoundLan);
                    }
                    $.LoadingOverlay("hide");
                }, function () {
                    $.LoadingOverlay("hide");
                    toastr.error($scope.NetworkErrorLan);
                    $scope.Load = false;
                })

            }

            ////// zones

            $scope.getParkingZones = function () {

                $scope.BZone = {
                    Name: "",
                    BuildingId: $scope.Apartment.Id
                }

                $scope.ViewVal = 6;

                $scope.ParkingZones = [];
                MainService.ParkingZonesByBuildingId($scope.Apartment.Id).then(function (response) {
                    $scope.ParkingZones = response.data;
                });
            }

            $scope.addParkingZone = function () {
                if ($scope.BZone.Name == "") {
                    toastr.warning("Enter Zone Name");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddParkingZone($scope.BZone).then(function (response) {
                        if (response.data) {
                            $scope.Load = false;
                            toastr.success($scope.SuccessLan);
                            $scope.getParkingZones();
                        } else {
                            $scope.Load = false;
                            toastr.error($scope.NetworkErrorLan);
                        }
                        $.LoadingOverlay("hide");
                    }, function () {
                        $.LoadingOverlay("hide");
                        toastr.error($scope.NetworkErrorLan);
                        $scope.Load = false;
                    })

                }
            }

            $scope.editParkingZones = function (data) {
                $scope.BZone = data;
            }

            $scope.selectedZoneToDelete = {};
            $scope.deleteParkingZone = function (data) {
                $scope.selectedZoneToDelete = data;
                $('#deleteModalZone').modal('show');
            }

            $scope.deleteZoneWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteParkingZone($scope.selectedZoneToDelete.Id).then(function (response) {
                    if (response.data == true) {
                        $scope.Load = false;
                        toastr.success($scope.SuccessLan);
                        $('#deleteModalZone').modal('hide');
                        $scope.getParkingZones();
                    } else {
                        $scope.Load = false;
                        toastr.error($scope.NetworkErrorLan);
                    }
                    $.LoadingOverlay("hide");
                }, function () {
                    $.LoadingOverlay("hide");
                    toastr.error($scope.NetworkErrorLan);
                    $scope.Load = false;
                })

            }

            ////// Slot

            $scope.getParkingSlots = function () {

                $scope.BSlot = {
                    Name: "",
                    ParkingZoneId: "",
                    BuildingId: $scope.Apartment.Id
                }

                $scope.ViewVal = 7;

                $scope.ParkingZones = [];
                MainService.ParkingZonesByBuildingId($scope.Apartment.Id).then(function (response) {
                    $scope.ParkingZones = response.data;
                });

                $scope.ParkingSlots = [];
                MainService.ParkingSlotsByBuildingId($scope.Apartment.Id).then(function (response) {
                    $scope.ParkingSlots = response.data;
                });
            }

            $scope.addParkingSlot = function () {
                if ($scope.BSlot.Name == "") {
                    toastr.warning("Enter Slot Name");
                } else if ($scope.BSlot.ParkingZoneId == "") {
                    toastr.warning("Select Zone");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddParkingSlot($scope.BSlot).then(function (response) {
                        if (response.data) {
                            $scope.Load = false;
                            toastr.success($scope.SuccessLan);
                            $scope.getParkingSlots();
                        } else {
                            $scope.Load = false;
                            toastr.error($scope.NetworkErrorLan);
                        }
                        $.LoadingOverlay("hide");
                    }, function () {
                        $.LoadingOverlay("hide");
                        toastr.error($scope.NetworkErrorLan);
                        $scope.Load = false;
                    })

                }
            }

            $scope.editParkingSlots = function (data) {
                $scope.BSlot = data;
            }

            $scope.selectedSloteToDelete = {};
            $scope.deleteParkingSlot = function (data) {
                $scope.selectedSloteToDelete = data;
                $('#deleteModalSlot').modal('show');
            }

            $scope.deleteSlotWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteParkingSlot($scope.selectedSloteToDelete.Id).then(function (response) {
                    if (response.data == true) {
                        $scope.Load = false;
                        toastr.success($scope.SuccessLan);
                        $('#deleteModalSlot').modal('hide');
                        $scope.getParkingSlots();
                    } else {
                        $scope.Load = false;
                        toastr.error($scope.NetworkErrorLan);
                    }
                    $.LoadingOverlay("hide");
                }, function () {
                    $.LoadingOverlay("hide");
                    toastr.error($scope.NetworkErrorLan);
                    $scope.Load = false;
                })

            }


        }]);
